import React from "react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { AnnouncementBar } from "./AnnouncementBar";

export const Layout = ({ children }) => (
  <div className="App grain min-h-screen flex flex-col">
    <AnnouncementBar />
    <Nav />
    <main className="flex-1">{children}</main>
    <Footer />
    <CartDrawer />
  </div>
);
